import React from "react";
import Box from "components/common/Box";
import Stack from "components/common/Stack";
import Text from "components/common/Text";
import { dateTimeHelper } from "helper/dateTime";
import { formatHelper } from "helper/format";
import {
  STATUS_COLOR,
  getBillingPlanType,
  getBillingProductName,
  getBillingStatusLabel,
} from "./billingHelpers";

/**
 * Mobile row card for billing / manage transaction history.
 * Pass showProductName={false} on product-scoped Manage Subscription.
 */
const BillingTransactionMobileCard = ({ data, showProductName = true }) => {
  const status = data?.paymentStatus;
  const statusColor = STATUS_COLOR[status] || "#111827";

  return (
    <Stack spacing={1.25}>
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
        <Box>
          <Text sx={{ fontSize: 12, color: "#9CA3AF", mb: 0.25 }}>
            Transaction Date
          </Text>
          <Text sx={{ fontSize: 14, fontWeight: 500, color: "#111827" }}>
            {data?.createdAt
              ? dateTimeHelper.format(data.createdAt, "$DD/$MM/$YYYY")
              : "NA"}
          </Text>
        </Box>
        <Text sx={{ fontSize: 14, fontWeight: 500, color: statusColor }}>
          {getBillingStatusLabel(status)}
        </Text>
      </Stack>

      <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
        {showProductName ? (
          <Box sx={{ minWidth: 0, pr: 1 }}>
            <Text sx={{ fontSize: 12, color: "#9CA3AF", mb: 0.25 }}>
              Product Name
            </Text>
            <Text sx={{ fontSize: 14, fontWeight: 500, color: "#111827" }}>
              {getBillingProductName(data)}
            </Text>
          </Box>
        ) : (
          <Box sx={{ minWidth: 0, pr: 1 }}>
            <Text sx={{ fontSize: 12, color: "#9CA3AF", mb: 0.25 }}>Plan Type</Text>
            <Text sx={{ fontSize: 14, fontWeight: 500, color: "#111827" }}>
              {getBillingPlanType(data)}
            </Text>
          </Box>
        )}
        <Box sx={{ textAlign: "right", flexShrink: 0 }}>
          <Text sx={{ fontSize: 12, color: "#9CA3AF", mb: 0.25 }}>
            Subscription Fee
          </Text>
          <Text sx={{ fontSize: 14, fontWeight: 500, color: "#111827" }}>
            {data?.paymentAmount
              ? formatHelper.currency(data.paymentAmount)
              : formatHelper.currency(0)}
          </Text>
        </Box>
      </Stack>

      {showProductName ? (
        <Box>
          <Text sx={{ fontSize: 12, color: "#9CA3AF", mb: 0.25 }}>Plan Type</Text>
          <Text sx={{ fontSize: 14, fontWeight: 500, color: "#111827" }}>
            {getBillingPlanType(data)}
          </Text>
        </Box>
      ) : null}
    </Stack>
  );
};

export default BillingTransactionMobileCard;
